import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdvancedMapPinType } from '../../../models/advancedMap.model';
import { BuildingPopupDto } from '../../../models/building-map.model';
import { DtPopupDto } from '../../../models/dt-map.model';
import { PolePopupDto } from '../../../models/pole-map.model';
import { DtService } from '../../../services/dt.service';
import { BuildingService } from '../../../services/building.service';
import { PoleService } from '../../../services/pole.service';
import { AiUploadBatchObjectsService } from 'shared-lib';
import { ArrowTooltipDirective } from '../../../directives/arrow-tooltip.directive';
import { ToastrService } from 'ngx-toastr';
import { GoogleMap } from "@angular/google-maps";
import { TaggedSubstationService } from '../../../services/tagged-substation.service';
import { CimSubstationPopupDto } from '../../../models/cim-substation-map.model';

@Component({
  standalone: true,
  selector: 'app-map-info-window',
  templateUrl: './map-info-window.component.html',
  styleUrls: ['./map-info-window.component.scss'],
  imports: [CommonModule, ArrowTooltipDirective, GoogleMap]
})
export class MapInfoWindowComponent implements OnInit {
  @Input() assetId!: number;
  @Input() type!: AdvancedMapPinType;
  @Output() imageClicked = new EventEmitter<string>();

  @Output() actionClicked = new EventEmitter<void>();
  @Output() closeWindow = new EventEmitter<void>();
  @Output() copyCoordinates = new EventEmitter<void>();
  @Output() generatedObjectUrl = new EventEmitter<string | null>();
  @Output() editLocation = new EventEmitter<PolePopupDto>();
  @Output() toggleSchematic = new EventEmitter<{ id: number; name: string }>();

  buildingPopup?: BuildingPopupDto;
  dtPopup?: DtPopupDto;
  cimSubstationPopup?: CimSubstationPopupDto;
  polePopup?: PolePopupDto;
  objPopup?: any;
  activeView: 'details' | 'schematic' | '3d' = 'details';

  coordinatesCopied: boolean = false;

  constructor(
    private buildingService: BuildingService,
    private dtService: DtService,
    private poleService: PoleService,
    private taggedSubstationService: TaggedSubstationService,
    private cd: ChangeDetectorRef,
    private batchObjService:AiUploadBatchObjectsService,
    private toastr:ToastrService
  ) { }

  ngOnInit(): void {
    if (this.type == AdvancedMapPinType.Building) {
      this.buildingService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.buildingPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.Dt) {
      this.dtService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.dtPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.Pole) {
      this.poleService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.polePopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.BatchObject) {
      this.batchObjService.getMapDetails(this.assetId).subscribe({
        next: (response: any) => {
          this.objPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.CimTransmissionStation || 
               this.type == AdvancedMapPinType.CimInjectionSubstation ||
               this.type == AdvancedMapPinType.CimDistributionSubstation
    ) {
      this.taggedSubstationService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.cimSubstationPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      });
    }
  }

  selectDetailsView(view: string) {
    this.activeView = view as 'details' | 'schematic' | '3d';
    if(this.activeView == '3d'){
      if(this.objPopup.generatedObjectUrl != null){
        this.generatedObjectUrl.emit(this.objPopup.generatedObjectUrl);
      }else{
        this.toastr.warning('No generated object available for this asset.');
      } 
      this.cd.detectChanges();
    } else if (this.activeView == 'schematic'){
      this.onToggleSchematic();
    }
  }

  onAction() {
    this.actionClicked.emit();
  }

  onToggleSchematic() {
    const templateInstanceId = this.cimSubstationPopup?.substationTemplateInstanceId ?? 0;
    const templateInstanceName = this.cimSubstationPopup?.name ?? '';

    this.toggleSchematic.emit({
      id: templateInstanceId,
      name: templateInstanceName
    });
  }


  onCloseWindow() {
    this.closeWindow.emit();
  }
  onImageClick(imageUrl: string) {
     this.imageClicked.emit(imageUrl);
  }
  onCopyCoordinates() {
    this.coordinatesCopied = true;
    this.cd.detectChanges();
    setTimeout(() => {
      this.coordinatesCopied = false;
      this.cd.detectChanges();
    }, 1500)
    this.copyCoordinates.emit();
  }

  getCoordinateString(latitude: number, longitude: number): string {
    return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
  }

  showEditMap: boolean = false;
    onEditClick() {
    this.editLocation.emit(this.polePopup);
    this.showEditMap = true;
  }

  notImplementedFullDetailsCim() {
    this.toastr.warning('Full Details for CIM assets are not implemented yet!');
  }
}
